
import { defineComponent, ref } from "vue";
import { getEnviromentUrl } from "@/utils/getEnvironmentURL";

export default defineComponent({
    name: "SkeletonLoader",
    data() {
        return {
            baseurl: getEnviromentUrl,
        };
    },
    props: {
        imgSrc: {
            type: String,
            required: true,
        },
    },
    setup() {
        const loaded = ref(false);
        return { loaded };
    },
    computed: {
        imageUrl() {
            return this.imgSrc !== "placeholder" ? this.baseurl + this.imgSrc : null;
        },
    },
});
